// Formats prices stored in dollars without dollar sign, ie.. 5 -> 5, 4.99 -> 4.99
export function formatPrice(price: number): string {
  // This checks to see if the price ends in .00, and drops it if so.
  const price_str = price.toFixed(2);
  return price_str.replace(/(\.\d*?)00+$/, "$1").replace(/\.$/, "");
}
